import { render, staticRenderFns } from "./TransferAccountRangeList.vue?vue&type=template&id=3f9afd45&"
import script from "./TransferAccountRangeList.vue?vue&type=script&lang=js&"
export * from "./TransferAccountRangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports